import isEnabled from '../../services/is-experiment-enabled';
export const getExperiments = (state) => { var _a; return (_a = state.experiments) !== null && _a !== void 0 ? _a : {}; };
export const isExperimentEnabled = (state, name, value) => {
    return isEnabled(getExperiments(state), name, value);
};
//# sourceMappingURL=experiments-selectors.js.map